import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'

export function Input({className = '', ...props}: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`ui-input ${className}`.trim()} />
}

export function Textarea({className = '', ...props}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={`ui-textarea ${className}`.trim()} />
}
